module.exports = __webpack_public_path__ + "img/5.975d6692.jpg";